import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  CreateCashAdjustmentApi,
  DeleteCashAdjustmentApi,
  GetCashAdjustmentsApi,
} from "../../ApiRequests";

export const fetchCashAdjustments = createAsyncThunk(
  "fetch/CashAdjustments",
  async () => {
    try {
      const response = await GetCashAdjustmentsApi();
      return response?.data?.data?.payload || [];
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

export const createCashAdjustment = createAsyncThunk(
  "create/CashAdjustment",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await CreateCashAdjustmentApi(payload);
      if (!response?.data?.success) {
        return rejectWithValue(response?.data?.error?.msg || "Failed to save");
      }
      return response.data.data.payload;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.error?.msg || error.message || "Failed to save"
      );
    }
  }
);

export const deleteCashAdjustment = createAsyncThunk(
  "delete/CashAdjustment",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DeleteCashAdjustmentApi(id);
      if (!response?.data?.success) {
        return rejectWithValue(
          response?.data?.error?.msg || "Failed to delete"
        );
      }
      return id;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.error?.msg ||
          error.message ||
          "Failed to delete"
      );
    }
  }
);

const CashAdjustmentSlice = createSlice({
  name: "cash-adjustment-data",
  initialState: {
    loading: false,
    creating: false,
    deleting: false,
    data: [],
    isError: false,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCashAdjustments.pending, (state) => {
      state.loading = true;
      state.isError = false;
    });
    builder.addCase(fetchCashAdjustments.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchCashAdjustments.rejected, (state) => {
      state.loading = false;
      state.isError = true;
    });

    builder.addCase(createCashAdjustment.pending, (state) => {
      state.creating = true;
      state.error = "";
    });
    builder.addCase(createCashAdjustment.fulfilled, (state, action) => {
      state.creating = false;
      if (action.payload) state.data = [action.payload, ...(state.data || [])];
    });
    builder.addCase(createCashAdjustment.rejected, (state, action) => {
      state.creating = false;
      state.isError = true;
      state.error = action.payload || "Failed to save";
    });

    builder.addCase(deleteCashAdjustment.pending, (state) => {
      state.deleting = true;
      state.error = "";
    });
    builder.addCase(deleteCashAdjustment.fulfilled, (state, action) => {
      state.deleting = false;
      state.data = (state.data || []).filter(
        (row) => String(row._id) !== String(action.payload)
      );
    });
    builder.addCase(deleteCashAdjustment.rejected, (state, action) => {
      state.deleting = false;
      state.isError = true;
      state.error = action.payload || "Failed to delete";
    });
  },
});

export default CashAdjustmentSlice.reducer;
